<template>
  <div>
    <i
      v-show="value == -1"
      class="fas fa-sort"
    />
    <i
      v-show="value == 0"
      class="fas fa-sort-up"
    />
    <i
      v-show="value == 1"
      class="fas fa-sort-down"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
};
</script>
